<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-form-item label="标题" required>
          <el-input size="medium" v-model="form.title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="优惠券标题" required>
          <el-input size="medium" v-model="form.coupon_title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" required>
          <el-date-picker v-model="form.start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" ></el-date-picker> ~
          <el-date-picker v-model="form.end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" ></el-date-picker>
        </el-form-item>
        <el-form-item label="领券时间" required>
          <el-date-picker v-model="form.coupon_start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" ></el-date-picker> ~
          <el-date-picker v-model="form.coupon_end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" ></el-date-picker>
        </el-form-item>
        <el-form-item label="下次领券时间">
          <el-date-picker v-model="form.coupon_next_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" ></el-date-picker> ~
          <el-date-picker v-model="form.coupon_next_end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" ></el-date-picker>
        </el-form-item>
        <el-form-item label="活动规则">
            <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="form.rule_content">
            </el-input>
        </el-form-item>

        <el-form-item label="分享图标" required>
            <activityCustomUpload :formName="'share_icon'" :formValue="form.share_icon" @uploadSuccess="uploadSuccess"></activityCustomUpload>
        </el-form-item>
        <el-form-item label="分享标题" required>
          <el-input size="medium" v-model="form.share_title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="分享描述" required>
          <el-input size="medium" autosize v-model="form.share_desc" style="width:600px"></el-input>
        </el-form-item>
        <template v-if="type != 'create'">
          <el-form-item label="活动链接" >
            {{form.url}} 
            <el-button type="primary" class="copy" @click="copy">复制</el-button>
          </el-form-item>
        </template>

        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import { getInfo, createActivityInfo, updateActivityInfo } from "@/api/activityCustom";

export default {
  components: { activityCustomUpload },
  data: function() {
    return {
      id:'',
      type:'create',
      form:{},
      onSubmitLoading:false,
      formLoading:false,
    };
  },
  created: function() {
    this.type = this.$route.query.type
    if(this.type == 'update'){
      this.id = this.$route.query.id;
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false;
        this.form = response.data;
      });
    },
    uploadSuccess(value){
      this.form[value.formName] = value.fileUrl
    },
    onUpdate(){
      this.onSubmitLoading = true;
      updateActivityInfo(this.form).then((res) => {
        this.onSubmitLoading = false;
        if(res.code == 1){
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    onSubmit(){
      this.onSubmitLoading = true;
      createActivityInfo(this.form).then((res) => {
        this.onSubmitLoading = false;
        if(res.code == 1){
          this.form = {}
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    backPrePage(){
      this.$router.go(-1);
    },
    copy(){
      let that = this
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return that.form.url
        }
      })
      clipboard.on('success', e => {
        this.$message({
            showClose: true,
            duration: 3000,
            message: '复制成功',
            type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  }
};
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    min-height: 70px;
    line-height: 70px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    min-height: 70px;
    display: block;
  }
</style>

